import React from 'react'

import './styles.css'

export default ({statistics}) => {
    return(
        <> 
        {
            statistics.length !== 0 ?
                <div className='modal-statistics'>

                    <div className='force-margin11'>
                        {/* QUAL IMPRESSAO VOCE TEVE DO LOCAL */}
                        <h2 className='modal-statistics-title'>Qual impressão você teve do local?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[0][0].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Pouco movimentado</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[0][1].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Mal iluminado</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[0][2].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Não frequentado por outras mulheres</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[0][3].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Outros</p>
                        </div>
                    </div>

                    <div className='force-margin11'>
                        {/* POR QUE VOCE SE SENTIU INSEGURA? */}
                        <h2 className='modal-statistics-title'>Por que você se sentiu insegura?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[1][0].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Tive a impressão de estar sendo encarada, fotografada, etc</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[1][1].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Tive a impressão de estar sendo seguida</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[1][2].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text '>Fui trancada/encurralada em um cômodo, banheiro, parede, etc</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[1][3].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Acho que alguem colocou algo na minha bebida sem autorização</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[1][4].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Outros</p>
                        </div>
                    </div>

                    <div className='force-margin11'>
                        {/* SUA INSEGURANÇA ESTÁ RELACIONADA AO POLICIAMENTO */}
                        <h2 className='modal-statistics-title'>Sua insegurança está relacionada ao policiamento?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[2][0].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Pela presença</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[2][1].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Pela ausência</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[2][2].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Não está relacionada ao policiamento</p>
                        </div>
                    </div>


                    <div className='force-margin11'>
                        {/* SOFREU ASSÉDIO */}
                        <h2 className='modal-statistics-title'>Sofreu assédio?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[3][0].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text force-margin29'>Constrangimento físico de natureza sexual (beijo forçado, passada de mão, estupro, etc... )</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[3][1].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text force-margin10'>Constrangimento físico de natureza diversa (empurrão, tapa, toque indesejado, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[3][2].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Importunação sexual (masturbação, mostrou o pênis, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[3][3].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Importunação sonora (buzina, gemido, assovio, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[3][4].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Importunação verbal (cantada, xingamento, ameaça, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[3][5].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text force-margin13'>Meu “não” foi ignorado (fui pressionada a dançar, a beber ou usar drogas, tirar a roupa, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[3][6].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Outros</p>
                        </div>
                    </div>

                    <div className='force-margin11'>
                        {/* Algum responsável pelo local (público/privado) tomou alguma providência? */}
                        <h2 className='modal-statistics-title'>Algum responsável pelo local (público/privado) tomou alguma providência?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[4][0].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Sim</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[4][1].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Não</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {statistics[4][2].toString().substring(0,3).replace(/\D+/g, '') + '%'}</p>
                            <p className='modal-statistics-text'>Não sei dizer</p>
                        </div>
                    </div>
                    
                </div>
            : 
                <div className='modal-statistics'>

                    <div className='force-margin11'>
                        {/* QUAL IMPRESSAO VOCE TEVE DO LOCAL */}
                        <h2 className='modal-statistics-title'>Qual impressão você teve do local?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Pouco movimentado</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Mal iluminado</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Não frequentado por outras mulheres</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Outros</p>
                        </div>
                    </div>

                    <div className='force-margin11'>
                        {/* POR QUE VOCE SE SENTIU INSEGURA? */}
                        <h2 className='modal-statistics-title'>Por que você se sentiu insegura?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Tive a impressão de estar sendo encarada, fotografada, etc</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Tive a impressão de estar sendo seguida</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text '>Fui trancada/encurralada em um cômodo, banheiro, parede, etc</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Acho que alguem colocou algo na minha bebida sem autorização</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Outros</p>
                        </div>
                    </div>

                    <div className='force-margin11'>
                        {/* SUA INSEGURANÇA ESTÁ RELACIONADA AO POLICIAMENTO */}
                        <h2 className='modal-statistics-title'>Sua insegurança está relacionada ao policiamento?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Pela presença</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Pela ausência</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Não está relacionada ao policiamento</p>
                        </div>
                    </div>


                    <div className='force-margin11'>
                        {/* SOFREU ASSÉDIO */}
                        <h2 className='modal-statistics-title'>Sofreu assédio?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text force-margin29'>Constrangimento físico de natureza sexual (beijo forçado, passada de mão, estupro, etc... )</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text force-margin10'>Constrangimento físico de natureza diversa (empurrão, tapa, toque indesejado, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Importunação sexual (masturbação, mostrou o pênis, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Importunação sonora (buzina, gemido, assovio, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Importunação verbal (cantada, xingamento, ameaça, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text force-margin13'>Meu “não” foi ignorado (fui pressionada a dançar, a beber ou usar drogas, tirar a roupa, etc...)</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Outros</p>
                        </div>
                    </div>

                    <div className='force-margin11'>
                        {/* Algum responsável pelo local (público/privado) tomou alguma providência? */}
                        <h2 className='modal-statistics-title'>Algum responsável pelo local (público/privado) tomou alguma providência?</h2>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Sim</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Não</p>
                        </div>
                        <div className='modal-statistics-content'>
                            <p className='modal-statistics-text percentage'> {'0 %'}</p>
                            <p className='modal-statistics-text'>Não sei dizer</p>
                        </div>
                    </div>
            
                </div>
        }
        </>
    )
}


/*
<table border=''>

                    <tr className='modal-statistics-content'>
                        <td className='modal-statistics-text percentage'> {statistics[0][0] + '%'}</td>
                        <td className='modal-statistics-text'>Pouco movimentado</td>
                    </tr>
                    <tr className='modal-statistics-content'>
                        <td className='modal-statistics-text percentage'> {statistics[0][1] + '%'}</td>
                        <td className='modal-statistics-text'>Mal iluminado</td>
                    </tr>
                    <tr className='modal-statistics-content'>
                        <td className='modal-statistics-text percentage'> {statistics[0][2] + '%'}</td>
                        <td className='modal-statistics-text'>Não frequentado por outras mulheres</td>
                    </tr>
                    <tr className='modal-statistics-content'>
                        <td className='modal-statistics-text percentage'> {statistics[0][3] + '%'}</td>
                        <td className='modal-statistics-text'>Outros</td>
                    </tr>
                </table> */